module.exports = __webpack_public_path__ + "img/kakeibo-budget-planner_B09K1TV1G6.a9b566b8.jpg";